import React from 'react'
import { TooltipRenderProps } from 'react-joyride'

import { useI18n } from 'builder/hooks/useI18n'
import { ButtonSize, ButtonTheme } from 'builder/components/Button'

import { EditorTourStepIndex } from '../types'
import { TRANSLATION_KEY } from '../utils'
import * as Styles from './styles'

type Props = TooltipRenderProps & {
  stepName: 'design' | 'editor' | 'download'
}

export const Tooltip: React.FC<Props> = ({ step, size, index, stepName, tooltipProps }) => {
  const { i18n } = useI18n()
  const isDownloadStep = stepName === 'download'
  const isDragStep = stepName === 'editor' && index === EditorTourStepIndex.DRAG_SECTIONS

  const getStepName = () => {
    if (isDownloadStep) return stepName
    return `${stepName} • ${index + 1} ${i18n.t(`${TRANSLATION_KEY}.of`)} ${size}`
  }

  return (
    <>
      <Styles.TooltipBody
        className="tooltip__body"
        {...tooltipProps}
        $isDragStep={isDragStep}
        style={{ ...step.styles.tooltipContainer, textAlign: 'start' }}
      >
        <Styles.TagContainer $isDownloadStep={isDownloadStep}>
          <Styles.Tag>
            <Styles.Step>{getStepName()}</Styles.Step>
          </Styles.Tag>
        </Styles.TagContainer>
        <Styles.TooltipContent>
          <Styles.TooltipHeader>
            <Styles.TooltipTitle className="tooltip__title">{step.title}</Styles.TooltipTitle>
            <Styles.TooltipSubHeader className="tooltip__content">
              {step.content}
            </Styles.TooltipSubHeader>
          </Styles.TooltipHeader>
          <Styles.SkipContainer>
            {step.showSkipButton && (
              <Styles.TooltipSkipButton
                onClick={() => step.data.onSkip?.()}
                size={ButtonSize.small}
                theme={ButtonTheme.secondary}
              >
                {i18n.t(`${TRANSLATION_KEY}.skip`)}
              </Styles.TooltipSkipButton>
            )}
          </Styles.SkipContainer>
        </Styles.TooltipContent>
      </Styles.TooltipBody>
    </>
  )
}
